import React from 'react';
import moment from "moment";

const TaskStatsSection = ({ title, tasks, documentsTitle }) => {
    const todayDocumentsValue = tasks.documents_today.document_ok + tasks.documents_today.document_ko;
    const pourcentageOk = Math.round(Number(tasks.documents_today.document_ok) / Number(todayDocumentsValue) * 100);
    const pourcentageKo = Math.round(Number(tasks.documents_today.document_ko) / Number(todayDocumentsValue) * 100);

    return (
        <div className={'row'}>
            <p className={'outer-title mt-5 ps-0'}>{title}</p>
            <div className={'col-3 mt-3 ps-0'}>
                <p className={'box-card p-3 h-100'}>
                    <span className={'f-12'}>Tâches<br/>traitées hier</span>
                    <br/>
                    <span className={'font-white f-32'}>{tasks.yesterday}</span>
                </p>
            </div>
            <div className={'col-3 mt-3'}>
                <p className={'box-card p-3 h-100'}>
                    <span className={'f-12'}>Tâches<br/>traitées aujourd'hui</span>
                    <br/>
                    <span className={'font-white f-32'}>{tasks.today}</span>
                </p>
            </div>
            <div className={'col-2 mt-3'}>
                <p className={'box-card p-3 h-100'}>
                    <span className={'f-12'}>Tâche<br/>la plus ancienne</span>
                    <br/>
                    <span className={'font-white f-26'}>{moment(tasks.older).format('DD/MM/YYYY')}</span>
                </p>
            </div>
            <div className={'col-4 mt-3 pe-0'}>
                <div className={'box-card p-3 h-100'}>
                    <p className={'outer-title mb-2'}>{documentsTitle}</p>
                    {todayDocumentsValue > 0 ?
                        <div className="progress">
                            <div className="progress-bar bg-success"
                                 role="progressbar"
                                 style={{width: pourcentageOk + '%'}}
                                 aria-valuenow={tasks.documents_today.document_ok}
                                 aria-valuemin="0"
                                 aria-valuemax={todayDocumentsValue}
                            >
                                <strong className={'m-2'}>{tasks.documents_today.document_ok} OK</strong>
                            </div>
                            <div className="progress-bar bg-danger"
                                 role="progressbar"
                                 style={{width: pourcentageKo + '%'}}
                                 aria-valuenow={tasks.documents_today.document_ko}
                                 aria-valuemin="0"
                                 aria-valuemax={todayDocumentsValue}
                            >
                                <strong>{tasks.documents_today.document_ko} KO</strong>
                            </div>
                        </div>
                        : <p>Pas de données pour aujourd'hui</p>
                    }
                </div>
            </div>
        </div>
    );
};

export default TaskStatsSection;